import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native'

import {
  DownloadButton,
  downloadReport
} from '../../elements/ReportDownload';
import SearchableSelect from 'app/src/elements/SearchableSelect';
import { sellerOptions, saleOptions } from './filterOptions';

import { cardStyles as styles } from './index';

const SalesAndExpenseReport = ({ data }) => {
  const [sellerId, setSellerId] = useState();
  const [soldStatus, setSoldStatus] = useState();
  const [saleId, setSaleId] = useState();

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'sales-and-expense-report',
      params: { 'sellerId': sellerId, status: soldStatus,'sale-id': saleId }
    }) }
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Sales and Expense Report</Text>
      <Text style={styles.label}>Seller:</Text>
      <SearchableSelect
        placeholder="Select Seller"
        options={sellerOptions(data)}
        value={sellerId}
        onChange={setSellerId}
      />
      <Text style={styles.label}>Sale:</Text>
      <SearchableSelect
        placeholder="Select Sale"
        options={saleOptions(data)}
        value={saleId}
        onChange={setSaleId}
      />
      <Text style={styles.label}>Sold Status:</Text>
      <select style={styles.select} onChange={(e) => setSoldStatus(e.target.value)}>
        <option key="status-all">All</option>
        <option key="status-sold">Sold</option>
        <option key="status-notSold">Not Sold</option>
      </select>
      <DownloadButton handleDownload={handleDownload} />
    </View>
  );
};

export default SalesAndExpenseReport;
